import React, { useState } from "react";
import "./SideBar.css";
import { NavLink } from "react-router-dom";

import {
  LayoutDashboard,
  Bookmark,
  Crosshair,
  Gift,
  Users,
  Bell,
  CreditCard,
  Info,
  Menu,
  LandPlot,
  X,
  UserCircle2,
} from "lucide-react";

const Sidebar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const menuItems = [
    {
      name: "My Profile",
      path: "/profile",
      icon: <UserCircle2 size={17} />,
    },
    {
      name: "Dashboard",
      path: "/dashboard",
      icon: <LayoutDashboard size={17} />,
    },
    {
      name: "Favourites",
      path: "/favourites",
      icon: <Bookmark size={17} />,
    },
    {
      name: "All Challenges",
      path: "/all-challenges",
      icon: <Crosshair size={17} />,
    },
    {
      name: "Checkpoints",
      path: "/rewards",
      icon: <Gift size={17} />,
    },
    {
      name: "Team Management",
      path: "/team-management",
      icon: <Users size={17} />,
    },
    {
      name: "Challenge Management",
      path: "/challenge-management",
      icon: <LandPlot size={17} />,
    },
    {
      name: "Notifications & Alerts",
      path: "/notifications",
      icon: <Bell size={17} />,
    },
    {
      name: "Payment & Orders",
      path: "/payments",
      icon: <CreditCard size={17} />,
    },
    {
      name: "More Info & Contact",
      path: "/contact-info",
      icon: <Info size={17} />,
    },
  ];

  const closeMobile = () => setMobileOpen(false);

  return (
    <>
      {/* MOBILE TOGGLE */}
      <div className="sidebarmobile-menu-btn">
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* OVERLAY */}
      {mobileOpen && <div className="sidebar-overlay" onClick={closeMobile} />}

      <div className={`sidebar ${mobileOpen ? "open" : ""}`}>
        {/* MENU ITEMS */}
        <div className="sidebar-menu">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end
              className={({ isActive }) =>
                isActive ? "menu-item active" : "menu-item"
              }
              onClick={closeMobile}
            >
              <span className="menu-icon">{item.icon}</span>
              <span>{item.name}</span>
            </NavLink>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
